module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"zh":{"new1":"行业新闻","title1":"企业简介","title2":"企业新闻","title3":"员工风采","title4":"供热须知","title5":"联系我们"},"ru":{"new1":"Новости отрасли","title1":"Корпоративный профиль","title2":"Динамика предприятий","title3":"Стиль работы","title4":"Здравый смысл отопления","title5":"Свяжитесь с нами"}}')
  delete Component.options._Ctor
}
